import React from "react";
import { useForm } from "react-hook-form";
import { CheckOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { DatePickerHook, InputHook, SelectHook } from "components/hook-forms";
import { ClearAllIcon } from "components/svgs/ClearAllIcon";

const STATUS_OPTIONS = [
  { name: "All", value: "" },
  // Tote statuses (before pickup)
  { name: "Open", value: "open" },
  { name: "Closed", value: "closed" },
  { name: "Picked Up", value: "pickedup" },
  // Job (stop) statuses once the tote is on a route
  { name: "Unassigned", value: "unassigned" },
  { name: "Assigned", value: "assigned" },
  { name: "Pickup Arrived", value: "pickup_arrived" },
  { name: "Collected", value: "collected" },
  { name: "Dropoff Arrived", value: "dropoff_arrived" },
  { name: "Completed", value: "completed" },
  { name: "Failed", value: "failed" },
  // Route plan statuses
  { name: "Pending", value: "pending" },
  { name: "Processing", value: "submitting" },
  { name: "Submitted", value: "submitted" },
  { name: "Route Created", value: "route_created" }
];

const FilterScan2Pack = ({
  defaultValues,
  setShowFilter,
  handleClickFilter,
  onReset
}) => {
  const {
    reset,
    getValues,
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: "onSubmit",
    defaultValues: defaultValues
  });

  const submitForm = async (values) => {
    handleClickFilter(values);
  };

  return (
    <div className="filter-order-component">
      <form onSubmit={handleSubmit(submitForm)}>
        <div className="wrap-form-filter">
          <InputHook
            control={control}
            placeholder="Tote / Plan ID"
            label="Tote / Plan ID"
            name="id"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <InputHook
            control={control}
            placeholder="Package ID"
            label="Package ID"
            name="packageId"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <InputHook
            control={control}
            placeholder="Packer Name"
            label="Packer Name"
            name="packerName"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <DatePickerHook
            control={control}
            getValues={getValues}
            placeholder="Created Date"
            label="Created Date"
            name="createdDate"
            showOptionsName={false}
            errors={errors}
          />
          <SelectHook
            showOptionsName={false}
            control={control}
            getValues={getValues}
            placeholder="All"
            label="Status"
            name="status"
            valueSelect="value"
            labelSelect="name"
            errors={errors}
            options={STATUS_OPTIONS}
            showSearch={true}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          />
        </div>
        <div className="wrap-button">
          <Button type="link" className="collapse" onClick={() => setShowFilter(false)}>
            Collapse <UpOutlined />
          </Button>
          <Button
            type="link"
            className="svg-icon clear"
            onClick={() => {
              reset();
              onReset();
            }}
          >
            Clear <ClearAllIcon />
          </Button>
          <Button type="primary" htmlType="submit">
            Apply <CheckOutlined />
          </Button>
        </div>
      </form>
    </div>
  );
};

export default FilterScan2Pack;
